export default __webpack_public_path__ + "static/media/uncheck.65e9fe29.svg";